import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { SessionProvider } from './auth/session'
import { applyTheme, getInitialTheme } from './theme'
import './styles.css'

// Before the first paint, not inside a component: doing it here means the
// page never flashes the wrong palette while React boots.
applyTheme(getInitialTheme())

const container = document.getElementById('root')
if (!container) throw new Error('no #root element')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
)
